import React, { useReducer, useEffect } from 'react';
import { TabContainerInner, TabContainerOuter } from '../styles';

interface Props {
    children?: any;
    currentSlide: number;
}

export const APPEND_WIDTH = 'APPEND_WIDTH';
const UPDATE_SLIDE_PADDING = 'UPDATE_SLIDE_PADDING';
const UPDATE_PREVENT_ANIMATION = 'UPDATE_PREVENT_ANIMATION';

const initialState = {
    tabWidths: [0],
    slideWidths: 0,
    preventAnimation: true,
};

const reducer = (state, action) => {
    const { type, payload, tabCount } = action;
    switch (type) {
        case APPEND_WIDTH: {
            if (state.tabWidths.length <= tabCount) {
                return { ...state, tabWidths: [...state.tabWidths, payload] };
            }
            return state;
        }
        case UPDATE_SLIDE_PADDING:
        case UPDATE_PREVENT_ANIMATION:
            return { ...state, ...payload };
        default:
            return state;
    }
};

const TabContainer: React.FC<Props> = ({ children: Children, currentSlide }) => {
    const [{ tabWidths, slideWidths, preventAnimation }, dispatch] = useReducer(
        reducer,
        initialState
    );

    useEffect(() => {
        const slide = currentSlide - 1;
        /** fixed constant required to maintain alignment */
        const slidePadding = slide > 0 ? 8 : 0;
        /** Calculates the width for translateX animation and passes it to emotion styling */
        dispatch({
            type: UPDATE_SLIDE_PADDING,
            payload: {
                slideWidths:
                    tabWidths.filter((_, i) => i <= slide).reduce((acc, val) => acc + val) -
                    slidePadding,
            },
        });
        if (preventAnimation && currentSlide > 1) {
            // prevent animation only for initial load
            dispatch({ type: UPDATE_PREVENT_ANIMATION, payload: { preventAnimation: false } });
        }
    }, [currentSlide]);

    return (
        <TabContainerOuter>
            <TabContainerInner slideWidths={-slideWidths}>
                {/* Children used in this way to append props */}
                <Children
                    dispatch={dispatch}
                    tabWidths={tabWidths}
                    preventAnimation={preventAnimation}
                />
            </TabContainerInner>
        </TabContainerOuter>
    );
};

export default TabContainer;
